// extracted by mini-css-extract-plugin
export var actionButton = "_jr-0";
export var fileInput = "_jr-2";
export var paperclip = "_jr-1";